export const FASTEN_PLATFORM_CANONICAL_IDS = [
    "epic",
    "cerner",
    "meditech",
    "athena",
    "eclinicalworks",
    "practicefusion",
    "allscripts",
    "nextgen",
    "advancedmd",
    "modmedema",
    "drchrono",
    "medhost",
    "chbase",
    "maximeyes",
    "netsmart",
    "qualifacts-carelogic",
    "qualifacts-credible",
    "qualifacts-insync",
    "onemedical",
    "vahealth",
    "medicare",
    "anthem",
    "unitedhealthcare",
    "aetna",
    "humana",
    "cigna",
    "bcbsal",
    "questdiagnostics",
    "darena",
    "careevolution",
    "dynamichealthit",
    "edifecs",
    "flatiron",
    "healthit",
    "logica",
];
export const FASTEN_PLATFORM_ENTITIES = [
    {
        id: "epic",
        category: "ehr",
        displayValue: "Epic",
        aliases: ["Epic", "Epic EHR", "MyChart", "MyChart Central"],
    },
    {
        id: "cerner",
        category: "ehr",
        displayValue: "Oracle Health",
        aliases: [
            "Oracle Health",
            "Oracle Health EHR",
            "Oracle Health Millennium",
            "Oracle Cerner",
            "Oracle Cerner Millennium",
            "Cerner",
            "Cerner EHR",
            "Cerner Millennium",
        ],
    },
    {
        id: "meditech",
        category: "ehr",
        displayValue: "Meditech",
        aliases: ["Meditech", "Meditech EHR", "MHealth", "PCHP"],
    },
    {
        id: "athena",
        category: "ehr",
        displayValue: "Athena",
        aliases: ["Athena", "Athena Health", "Athena EHR", "athenaOne", "athenaNet", "athenaPatient"],
    },
    {
        id: "eclinicalworks",
        category: "ehr",
        displayValue: "eClinicalWorks",
        aliases: ["eClinicalWorks", "eCW", "healow"],
    },
    {
        id: "practicefusion",
        category: "ehr",
        displayValue: "Practice Fusion",
        aliases: ["Practice Fusion", "Practice Fusion EHR"],
    },
    {
        id: "allscripts",
        category: "ehr",
        displayValue: "Allscripts",
        aliases: ["Allscripts", "Allscripts EHR", "Altera", "Veradigm", "Veradigm EHR", "Professional EHR", "FollowMyHealth", "FMH"],
    },
    {
        id: "nextgen",
        category: "ehr",
        displayValue: "NextGen",
        aliases: ["NextGen", "NextGen Healthcare", "NextGen EHR", "NextMD"],
    },
    {
        id: "advancedmd",
        category: "ehr",
        displayValue: "Advanced MD",
        aliases: ["Advanced MD", "AdvancedEHR", "AdvancedMD EHR"],
    },
    {
        id: "modmedema",
        category: "ehr",
        displayValue: "ModMed",
        aliases: ["ModMed"],
    },
    {
        id: "drchrono",
        category: "ehr",
        displayValue: "Dr Chrono",
        aliases: ["Dr Chrono", "DrChrono EHR"],
    },
    {
        id: "medhost",
        category: "ehr",
        displayValue: "Medhost",
        aliases: ["Medhost", "Medhost EHR"],
    },
    {
        id: "chbase",
        category: "ehr",
        displayValue: "CharmHealth",
        aliases: ["CharmHealth", "Charm", "Charm EHR"],
    },
    {
        id: "maximeyes",
        category: "ehr",
        displayValue: "MaximEyes",
        aliases: ["MaximEyes", "MaximEyes EHR"],
    },
    {
        id: "netsmart",
        category: "ehr",
        displayValue: "Netsmart",
        aliases: ["Netsmart", "myAvatar", "Netsmart Avatar"],
    },
    {
        id: "qualifacts-carelogic",
        category: "ehr",
        displayValue: "Carelogic",
        aliases: ["Carelogic", "Qualifacts Carelogic"],
    },
    {
        id: "qualifacts-credible",
        category: "ehr",
        displayValue: "Credible",
        aliases: ["Credible", "Credible Behavioral Health", "Qualifacts Credible"],
    },
    {
        id: "qualifacts-insync",
        category: "ehr",
        displayValue: "InSync",
        aliases: ["InSync", "Qualifacts InSync", "InSync Healthcare Solutions"],
    },
];
